export const SEARCH_SCOPES = [
    { value: 'all', text: 'Tutto' },
    { value: 'articles', text: 'Articoli' },
    { value: 'odp', text: 'ODP' },
    { value: 'nesting', text: 'Nesting' },
    { value: 'ddt', text: 'DDT' },
    { value: 'sales', text: 'Ordini clienti' },
];
export const normalizeScope = value => SEARCH_SCOPES.some(scope => scope.value === value) ? value : 'all';
export const usesIndex = scope => ['all', 'articles', 'odp'].includes(scope);
export const scopeFacetFilters = scope => scope === 'articles' ? ['route:Articolo'] : scope === 'odp' ? ['route:Ordine'] : [];
export const searchRoute = (query, scope = 'all') => ({ name: 'Search', params: query?.trim() ? { query: query.trim() } : {}, query: { mode: 'all', scope: normalizeScope(scope) } });
export const searchHint = scope => ({
    all: 'Codice, descrizione o riferimento. Scegli un tipo per restringere la ricerca.',
    articles: 'Codice articolo, descrizione o riferimento cliente.',
    odp: 'Numero ODP, articolo o descrizione.',
    nesting: 'Codice nesting completo o parziale, almeno 2 caratteri.',
    ddt: 'Numero DDT completo o almeno 3 cifre, anche senza prefisso DDT.',
    sales: 'Numero ODV o riferimento ordine del cliente, almeno 3 caratteri. Include ordini aperti e chiusi.',
}[scope]);
export function resultTypeLabel(hit) {
    return ({ Articolo: 'Articolo', Ordine: 'ODP', OrdineVendita: 'Ordine cliente', DdtDettaglio: 'DDT', 'laser-nesting-detail': 'Nesting', 'av-operatore': 'Fase ODP' })[hit.route] || 'Altro risultato';
}
export function canReadSalesOrders(user) {
    return Boolean(user?.admin || user?.is_superuser || (user?.groups || []).some(group => ['Amministrazione', 'Magazzino', 'Schedulazione', 'Tempi&Metodi'].includes(group)));
}
